module.exports = __webpack_public_path__ + "db0ff1155a5baeff3ab91424fc195c0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/Sec-1/churned-lp-mobile-bg.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/Sec-1/churned-lp-mobile-bg.jpg
// module chunks = 40